// extracted by mini-css-extract-plugin
export default {"topBuyers":"g5kq3vUAZWrJWmxsCCli__topBuyers___","buyers":"PcQaQnHrvIiu5iTaycPA__buyers___"};